import { format, formatDistanceToNow, getTime } from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date, newFormat = "dd MMM yyyy") {
	return date ? format(new Date(date), newFormat) : "";
}

export function fDateTime(date: number | string | Date | null, newFormat = "dd MMM yyyy p") {
	return date ? format(new Date(date), newFormat) : "";
}

export function fTimestamp(date) {
	return date ? getTime(new Date(date)) : "";
}

export function fToNow(date) {
	return date
		? formatDistanceToNow(new Date(date), {
				addSuffix: true,
			})
		: "";
}
